import type { ToolMode } from "#canvas/types.ts";
import { Tool } from "#canvas/types.ts";
export type { BrushSize } from "@pixelpuf/schemas/brush";
export { BRUSH_SIZE_VALUES, BrushSizeSchema } from "@pixelpuf/schemas/brush";

export const ROWS = 32;
export const COLS = 32;
export const INITIAL_FRAME_COUNT = 1;
export const MAX_FRAME_COUNT = 64;
export const AUTOSAVE_KEY = "pxpf:autosave";

export const PALETTE: readonly string[] = [
  "#FFFFFF",
  "#A0A0A0",
  "#606060",
  "#000000",
  "#E13838",
  "#FF7B29",
  "#FFB000",
  "#F4D03F",
  "#FF1F8F",
  "#E94B4B",
  "#33C24D",
  "#1E8E3E",
  "#3FB6E0",
  "#3B6FE0",
  "#7B61FF",
  "#C08050",
];

export const TOOLS: readonly { mode: ToolMode; label: string; icon: string }[] = [
  {
    mode: { kind: "brush", brush: Tool.DRAW },
    label: "Draw",
    icon:
      "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75",
  },
  {
    mode: { kind: "brush", brush: Tool.ERASER },
    label: "Erase",
    icon:
      "M16.24 3.56l4.95 4.94a2 2 0 0 1 0 2.83L11.66 21H7.41l-4.95-4.95a2 2 0 0 1 0-2.83L13.41 3.56a2 2 0 0 1 2.83 0Z",
  },
  {
    mode: { kind: "brush", brush: Tool.FILL },
    label: "Fill",
    icon: "M19 11l-9-9-9 9 9 9 9-9zm-9 7.59L4.41 13H15.59L10 18.59z",
  },
  {
    mode: { kind: "brush", brush: Tool.SELECT },
    label: "Select",
    icon: "M3 3h4v2H5v2H3V3zm14 0h4v4h-2V5h-2V3zM3 17h2v2h2v2H3v-4zm16 0h2v4h-4v-2h2v-2z",
  },
  { mode: { kind: "brush", brush: Tool.LINE }, label: "Line", icon: "M3 21L21 3" },
  { mode: { kind: "brush", brush: Tool.RECTANGLE }, label: "Rect", icon: "M3 3h18v18H3z" },
  {
    mode: { kind: "brush", brush: Tool.ELLIPSE },
    label: "Ellipse",
    icon: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
  },
  {
    mode: { kind: "picker" },
    label: "Picker",
    icon: "M12 2v4M12 18v4M2 12h4M18 12h4M16 8a4 4 0 1 0-8 0 4 4 0 0 0 8 0z",
  },
];

// shared className fragments
export const TOPBTN =
  "bg-bg-3 border border-line text-text px-2 py-1 lg:px-3 lg:py-1.5 rounded-sm cursor-pointer hover:border-accent";
export const TOPBTN_WARN =
  "bg-bg-3 border border-danger/50 text-danger px-2 py-1 lg:px-3 lg:py-1.5 rounded-sm cursor-pointer hover:border-danger hover:text-danger";
export const SECTION = "p-3 border-b border-line";
export const SECTION_H = "m-0 mb-2 text-[10px] tracking-[1.4px] text-dim font-semibold uppercase";
